import Vue from "vue";
import Component from "vue-class-component";

@Component
export class GhTableBus extends Vue {}
